import { render, staticRenderFns } from "./UpdateAvatar.vue?vue&type=template&id=5a20daa6&"
import script from "./UpdateAvatar.vue?vue&type=script&lang=ts&"
export * from "./UpdateAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports